<template lang="pug">
  .image-slider(
    v-touch:swipe.left="swipeHandlerLeft"
    v-touch:swipe.right="swipeHandlerRight"
  )
    .image-slider__content(
      ref="sliderContent"
      :style="{ width: (sliderCount * 100) + '%', transform: 'translate('+ sliderTransition +'%)', transition: 'transform 0.5s' }"
    )
      .image-slider__slide(
        v-if="computedDataImages.length > 0"
        v-for="image in computedDataImages"
      )
        img(
          :src="image"
        )
      .image-slider__slide(
        v-if="computedDataImages.length === 0"
      )
        img(
          src="@/assets/images/default/camp.jpg"
        )
    .image-slider__buttons
      .image-slider-button.image-slider-button_left(
        @click="onArrowLeft()"
      )
        img(src="@/assets/images/icons/white-arrow.svg")
      .image-slider-button.image-slider-button_right(
        @click="onArrowRight()"
      )
        img(src="@/assets/images/icons/white-arrow.svg")
    .image-slider__paginator.image-slider-paginator
      .image-slider-paginator__container
        .image-slider-paginator__button(
          v-for="(image, $index) in computedDataImages"
          :class="{ 'image-slider-paginator__button_active': $index + 1 === currentSlider }"
        )
</template>

<script>
export default {
  name: "imageSlider",
  props: {
    dataImages: {
      type: Array,
      default: () => []
    },
    activeSlide: {
      type: Number,
      default: 0
    },
    elementId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      sliderTransition: 0,
      sliderCount: 1,
      currentSlider: 1,
      buttons: [],
      paginationContainer: null
    };
  },
  methods: {
    swipeHandlerLeft() {
      const e = arguments ? arguments[1] : false;
      if (!e) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      this.onArrowRight();
    },
    swipeHandlerRight() {
      const e = arguments ? arguments[1] : false;
      if (!e) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      this.onArrowLeft();
    },
    onArrowRight() {
      if (this.currentSlider > this.sliderCount - 1) {
        this.sliderTransition = 0;
        this.currentSlider = 1;
      } else {
        this.sliderTransition -= 100 / this.sliderCount;
        this.currentSlider += 1;
      }
      this.$emit("onslider", this.elementId, this.currentSlider);
      this.horizontalScrolling("forward");
    },
    onArrowLeft() {
      if (this.currentSlider < 2) {
        this.currentSlider = this.sliderCount;
        this.sliderTransition =
          -(this.currentSlider - 1) * (100 / this.sliderCount);
      } else {
        this.sliderTransition += 100 / this.sliderCount;
        this.currentSlider -= 1;
      }
      this.horizontalScrolling("back");
    },
    horizontalScrolling(direction) {
      const el = this.buttons[this.currentSlider - 1];
      let hiddenEl;
      const width = this.paginationContainer.parentElement.offsetWidth;
      const marginLeft = this.paginationContainer.style.marginLeft;
      const buttonMarginRight = 4;

      if (direction === "forward") {
        hiddenEl = this.buttons[this.currentSlider + 1]; // Скрытая кнопка справа через одну от активной
        if (this.currentSlider === 1) {
          this.paginationContainer.style.marginLeft = 0;
        } else if (!hiddenEl) {
          return false;
        } else if (
          hiddenEl.offsetLeft >
          width - Math.abs(parseInt(marginLeft))
        ) {
          this.paginationContainer.style.marginLeft =
            -1 *
              (hiddenEl.offsetLeft -
                width +
                el.offsetWidth +
                buttonMarginRight -
                parseInt(marginLeft)) +
            "px";
        }
      } else if (direction === "back") {
        hiddenEl = this.buttons[this.currentSlider - 3]; // Скрытая кнопка слева через одну от активной
        if (this.currentSlider === this.buttons.length) {
          this.paginationContainer.style.marginLeft =
            -1 * (el.offsetLeft - width + el.offsetWidth + buttonMarginRight) +
            "px";
        } else if (!hiddenEl) {
          return false;
        } else if (hiddenEl.offsetLeft < 0) {
          this.paginationContainer.style.marginLeft =
            parseInt(marginLeft) -
            (hiddenEl.offsetLeft - buttonMarginRight) +
            "px";
        }
      }
    }
  },
  computed: {
    computedDataImages: {
      cache: false,
      get() {
        const dataImages = this.dataImages;
        return dataImages;
      }
    }
  },
  mounted() {
    this.sliderCount = this.computedDataImages.length || 1;
    if (this.activeSlide > 0) {
      this.currentSlider = this.activeSlide + 1;
      this.sliderTransition =
        -(this.currentSlider - 1) * (100 / this.sliderCount);
    }
    this.paginationContainer = this.$el.querySelector(
      ".image-slider-paginator__container"
    );
    this.paginationContainer.style.marginLeft = 0;
    this.buttons = this.paginationContainer.children;
  },
  watch: {
    computedDataImages(newVal) {
      this.sliderCount = newVal.length || 1;
    },
    activeSlide(activeSlide) {
      if (activeSlide + 1 !== this.currentSlider) {
        this.$refs.sliderContent.style.transition = "none";
        this.currentSlider = activeSlide + 1;
        this.sliderTransition =
          -(this.currentSlider - 1) * (100 / this.sliderCount);
        setTimeout(() => {
          this.$refs.sliderContent.style.transition = "transform 0.5s";
        }, 500);
      }
    }
  }
};
</script>
